import { IResult } from "../interface/IResult";
import { IAuthSignatoryResponse } from "../interface/contingency/IAuthSignatoryResponse";
import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";

enum ContigencyServiceEnum {
    regenerate = "restart/terms",
    getTermForRestartByTradeId = "terms/restart/",
    getAuths = "auths/term",
    alterSendAuthCedente = "send/auth/term/cedente"
}

export default class Contigency extends ApiService {
    constructor(restClient: AxiosInstance) {
        super(restClient, "/contigency/");
    }

    public regenerate = async (tradeId: number, documentDigitalId: number) => {
        const data = this.POST(ContigencyServiceEnum.regenerate + `?tradeId=${tradeId}&documentDigitalId=${documentDigitalId}`, null);

        return data;
    };

    public alterSendAuthCedente = async (tradeId: number, authForUpdate: string) => {
        const data = this.PUT(ContigencyServiceEnum.alterSendAuthCedente + `?tradeId=${tradeId}&authForUpdate=${authForUpdate}`, null);

        return data;
    };

    public getTermForRestartByTradeId = async (tradeId: number): Promise<any> => await this.GET(ContigencyServiceEnum.getTermForRestartByTradeId + tradeId);

    public getAuths = async (): Promise<IResult<IAuthSignatoryResponse[]>> => this.GET(ContigencyServiceEnum.getAuths);
}



// WEBPACK FOOTER //
// ./src/services/api/Contigency.service.ts